export const SupportUser = {
  user: 'user',
  manager: 'manager',
  admin: 'admin',
  support: 'support'
};
/** We will be updating this version with every release to the Test environment.  */
export const portalVersion = "5.5";

export const featureCategories = {
  fill: 'fill',
  drain: 'drain',
  filtration: 'filtration',
  waterFeature: 'waterFeature',
  spillover: 'spillover',
  heat: 'heat'
};  

export const waterFeatureIconTypes = {
  laminarJet: 'icon_laminar_jet',
  deckJet: 'icon_deck_jet',
  miniJet: 'icon_mini_jet',
  spaJets: 'icon_spa_jets',
  vanishingEdge: 'icon_vanishing_edge',
  bubbler: 'icon_bubbler',
  sheerDescent: 'icon_sheer_descent',
  sheerArc: 'icon_sheer_arc',
  curtainWaterfall: 'icon_curtain_waterfall',
  slide: 'icon_slide',
  lazyRiver: 'icon_lazy_river',
  fountain: 'icon_fountain',
  fireBowl: 'icon_fire_bowl',
  suctionCleaner: 'icon_suction_cleaner',
  pressureCleaner: 'icon_pressure_cleaner'
};

export const featureIconMap: { [key: string]: string } = {
  waterFeature: 'assets/img/fountain.svg',
  filtration: 'assets/img/pool-filtration.svg',
  fill: 'assets/img/spa-fill.svg',
  drain: 'assets/img/spa-drain.svg',
  spillover: 'assets/img/spillover.svg',
  heat: 'assets/img/heat.svg',
  jandy: 'assets/img/icon_auxJandyLight.svg',
  chiller: 'assets/img/snowflake.svg',
  aux: 'assets/img/icon_auxWhiteLight.svg',
  thermostat: 'assets/img/heat.svg',
  lightGroup: 'assets/img/icon_lightGroup.svg',
  auto: 'assets/img/thermostat_auto.svg',
  chill: 'assets/img/snowflake.svg',
  airBlower: 'assets/img/icon_auxBlower.svg',
  fireBowl: 'assets/img/fire-feature.svg',
  cleaner: 'assets/img/icon_pressure_cleaner.svg'
};

export const auxJandyLightColorMap: { [key: number]: string } = {
  1: "alpineWhite",
  2: "skyBlue",
  3: "cobaltBlue",
  4: "caribbeanBlue",
  5: "springGreen",
  6: "emeraldGreen",
  7: "emeraldRose",
  8: "magenta",
  9: "violet",
  10: "slowColorSplash",
  11: "fastColorSplash",
  12: "americanBeauty",
  13: "fatTuesday",
  14: "discoTech",
};

export const lowVoltageEquipmentTypes: string[] = [
    'lowVoltageGasHeater',
    'lowVoltageHeatPump',
    'lowVoltageChiller',
    'lowVoltageHeatPumpWithChiller'
  ];
export const LowVoltageEquipmentLabelMap: Record<string, string> = {
  lowVoltageGasHeater: 'Gas Heater',
  lowVoltageHeatPump: 'Heat Pump - Heat Only',
  lowVoltageChiller: 'Chiller',
  lowVoltageHeatPumpWithChiller: 'Heat Pump - Heat and Chill'
};
export const auxiliaryEquipmentTypes: string[] = [
  'auxOther',
  'auxPump',
  'auxJandyLight',
  'auxWhiteLight',
  'auxBlower',
  'auxFirebowl',
  'auxSwc'
];

export const aqualinkEdge = 'AquaLink Edge'

export const  waterFeatureOrder = [
  'watertempSensor',
  'vsPump',
  'waterFeaturePump',
  'auxPump',
  'boosterPump',
  'gasHeater',
  'heatPump',
  'lowVoltageChiller',
  'solartempSensor',
  'sanitizer',
  'sanitizerGen2',
  'waterAnalyzer',
  'lightGroup',
  'infiniteWaterColorGroup',
  'auxJandyLight',
  'auxWhiteLight',
  'flowRateMeter',
  'airBlower',
  'fireFeature',
  'jandyValve'
];

export const deviceAlreadyProvisioned = "Device Already Provisioned";

export const statusLabelMap: { [key: string]: string } = {
  normal: 'Normal',
  needsAttention: 'Needs Attention',
  actionRequired: 'Action Required',
  '-': '-',
  '': '-'
};

export const statusIconMap: { [key: string]: string } = {
  normal: 'assets/img/normal-status.svg',
  needsAttention: 'assets/img/needs-attention.svg',
  actionRequired: 'assets/img/action-required.svg',
  '-': 'assets/img/unknown.svg',
  '': 'assets/img/unknown.svg'
};

export const maskedValue = '********';